/* global Razorpay */
import React, {useState, useEffect, useRef} from "react";
/*import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faEye, faEyeSlash} from "@fortawesome/free-solid-svg-icons";*/
import "./registrationFrom.css";
import step1 from "assets/choosePlan-image/icon_step1_choose_plan_active.svg";
import step2 from "assets/choosePlan-image/icon_step2_choose_plan_active.svg";
import step3 from "assets/choosePlan-image/icon_step3_choose_plan.svg";
import {useLocation, useNavigate, Link} from "react-router-dom";
import {postQuery, getQuery} from "api";
import {
    API_REGISTRATION, API_CHECK_EMAIL, API_CHECK_DOMAIN, API_CITY_LIST,
} from "utils/apiEndPoints";
import Meta from "utils/meta";
import CountryCodeList from "utils/countryCode";
import PricingHeader from "../../Component/PricingHeader/pricingHeader";

const RegistrationForm = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const {package_id} = location.state || {};
    const [isLoading, setIsLoading] = useState(false);
    const [errors, setErrors] = useState({});
    const [otpReSent, setOtpReSent] = useState("");
    const [sentOtp, setSentOtp] = useState("");
    const [sentEmail, setSentEmail] = useState("");
    const [resendOtpDisabled, setResendOtpDisabled] = useState(false);
    const [isOtpExpired, setIsOtpExpired] = useState(false);
    const [otpExpiresTime, setOtpExpiresTime] = useState(120);
    const [reSendTimer, setReSendTimer] = useState(60);
    const [isOtpFormVisible, setIsOtpFormVisible] = useState(false);
    const [isRegisterFormVisible, setIsRegisterFormVisible] = useState(true);
    /*const [passwordVisible, setPasswordVisible] = useState(false);*/
    const [cityList, setCityList] = useState([]);
    const [cityInput, setCityInput] = useState("");
    const [filteredCities, setFilteredCities] = useState([]);
    const [localityInput, setLocalityInput] = useState("");
    const [predictions, setPredictions] = useState([]);
    const inputRef = useRef(null);
    const [isCheckedTermsAndCond, setIsCheckedTermsAndCond] = useState(false);

    useEffect(() => {
        if(!package_id) {
            navigate("/choose-plan");
        } else {
            getCityList();
        }
        const script = document.createElement("script");
        script.src = "https://checkout.razorpay.com/v1/checkout.js";
        script.async = true;
        document.body.appendChild(script);
    }, []);

    const [formData, setFormData] = useState({
        salutation: "",
        first_name: "",
        last_name: "",
        email: "",
        country_code: "+91",
        contact_no: "",
        identification_proof: null,
        identification_no: "",
        company_name: "",
        gst_no: "",
        address_1: "",
        address_2: "",
        city: "",
        locality: "",
        package_id: package_id || "",
    });

    const [otpFormData, setOtpFormData] = useState({
        otp: "",
    });

    const getCityList = async () => {
        try {
            const cityResponse = await getQuery(API_CITY_LIST);
            if (cityResponse?.data?.success === 1) {
                const cityList = cityResponse?.data?.data?.city;
                setCityList(cityList);
            } else {
                console.error("Error fetching city list: Invalid response", cityResponse?.error);
            }
        } catch (error) {
            console.error("Error fetching city list:", error.message || error);
        }
    };

    const handleCitySelect = (selectedCity) => {
        setCityInput(selectedCity.city);
        setFormData((prevFormData) => ({
            ...prevFormData, city: selectedCity.eloc,
        }));
        setFilteredCities([]);
        setErrors((prevErrors) => ({...prevErrors, city: ""}));
    };

    const handleCityInputChange = (e) => {
        const {value} = e.target;
        setCityInput(value);
        if (value.trim() !== "") {
            const filtered = cityList.filter((city) => city.city.toLowerCase().includes(value.toLowerCase()));
            setFilteredCities(filtered);
        } else {
            setFilteredCities([]);
        }
        setFormData((prevFormData) => ({
            ...prevFormData, city: "",
        }));
    };

    const handleLocalityInputChange = async (e) => {
        const input = e.target.value;
        setLocalityInput(input);
        if (!input.trim()) {
            setPredictions([]);
            return;
        }
        try {
            const googleMapServer = new window.google.maps.places.AutocompleteService();
            googleMapServer.getPlacePredictions({
                input, types: [],
            }, (predictions, status) => {
                if (status === window.google.maps.places.PlacesServiceStatus.OK) {
                    const filteredPredictions = predictions.map((prediction) => ({
                        description: prediction.structured_formatting.main_text,
                        fullDescription: prediction.structured_formatting.secondary_text,
                        placeId: prediction.place_id,
                    }));
                    setPredictions(filteredPredictions);
                } else {
                    setPredictions([]);
                }
            });
        } catch (error) {
            console.error("Error fetching Google Maps predictions:", error);
            setPredictions([]);
        }
    };

    const handleLocalitySelect = async (prediction) => {
        setLocalityInput(prediction.description);
        try {
            const geocoder = new window.google.maps.Geocoder();
            const result = await geocoder.geocode({placeId: prediction.placeId});
            if (result?.results?.length) {
                const address = result.results[0];
                const newFormattedAddress = address.formatted_address;
                const addressParts = newFormattedAddress.split(",");
                let address_1 = addressParts.slice(0, addressParts.length - 5).join(", ").trim();
                if(formData.address_1 !== "") {
                    address_1 = formData.address_1;
                }
                const subLocality_level_2 = address.address_components.find((component) => component.types.includes("sublocality_level_2"))?.long_name;
                const subLocality_level_1 = address.address_components.find((component) => component.types.includes("sublocality_level_1"))?.long_name;
                const formattedLocality = prediction.description;
                let address_2 = [subLocality_level_2, subLocality_level_1].filter(Boolean).join(", ");
                if(formData.address_2 !== "") {
                    address_2 = formData.address_2;
                }
                const city = address.address_components.find((component) => component.types.includes("administrative_area_level_3"))?.long_name;
                const placeId = address.place_id;
                const latitude = address.geometry.location.lat();
                const longitude = address.geometry.location.lng();
                if(cityInput === "") {
                    setCityInput(city || "");
                }
                const selectedCity = cityList.find((cityObj) => cityObj.city.toLowerCase() === city?.toLowerCase());
                if (selectedCity) {
                    setFormData((prevFormData) => ({
                        ...prevFormData, city: selectedCity.eloc,
                    }));
                } else {
                    setFormData((prevFormData) => ({
                        ...prevFormData, city: "",
                    }));
                }
                setFormData((prevFormData) => ({
                    ...prevFormData,
                    locality: formattedLocality,
                    address_1: address_1 || "",
                    address_2: address_2 || "",
                    locality_eloc: placeId,
                    locality_lat: latitude,
                    locality_lng: longitude,
                }));
                setErrors((prevErrors) => ({...prevErrors, locality: ""}));
            }
        } catch (error) {
            console.error("Error fetching locality details:", error);
        }
        setPredictions([]);
    };

    // form validation
    const dataValidation = () => {
        const newErrors = {};
        if (!formData.salutation) {
            newErrors.salutation = "Title is required.";
        }
        if (!formData.first_name) {
            newErrors.first_name = "First Name is required.";
        }
        if (!formData.email) {
            newErrors.email = "Email is required.";
        } else if (!formData.email || !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(formData.email)) {
            newErrors.email = "Please enter a valid email address.";
        }
        if (!formData.contact_no || !/^\d{10}$/.test(formData.contact_no)) {
            newErrors.contact_no = "Please enter a valid 10-digit mobile number.";
        }
        if (!formData.identification_proof) {
            newErrors.identification_proof = "Identification Proof is required.";
        } else {
            const allowedTypes = ["image/jpeg", "image/png", "image/jpg", "image/svg+xml", "application/pdf",];
            if (!allowedTypes.includes(formData.identification_proof.type)) {
                newErrors.identification_proof = "Invalid file type. Only JPG, JPEG, PNG, SVG, and PDF are allowed.";
            }
        }
        if (!formData.company_name) {
            newErrors.company_name = "Company Name is required.";
        }
        if (!formData.address_1) {
            newErrors.address_1 = "Address is required.";
        }
        if (!formData.address_2) {
            newErrors.address_2 = "Address 2 is required.";
        }
        if (!formData.locality) {
            newErrors.locality = "Locality is required.";
        }
        if (!formData.city) {
            newErrors.city = "City is required.";
        }
        /*if (!formData.password) {
            newErrors.password = "Password is required.";
        }*/
        return newErrors;
    };

    // handle input fields
    const handleInputChange = (e) => {
        const {name, value, type, files} = e.target;
        setFormData((prev) => ({
            ...prev, [name]: type === "file" ? files[0] : value,
        }));
        if (name === "email") {
            setFormData((prev) => ({
                ...prev, email: value, franchisee_email: value,
            }));
        }
        if (name === "gst_no") {
            setFormData((prev) => ({
                ...prev, gst_no: value, gstin: value,
            }));
        }
        setErrors((prev) => ({...prev, [name]: ""}));
    };

    // handle company fields
    const handleCompanyNameChange = async (e) => {
        const {name, value} = e.target;
        let validateCompanyName = name === "company_name" ? value.replace(/[^a-zA-Z0-9]/g, "").toLowerCase() : value;
        setFormData((prev) => ({
            ...prev, [name]: value, franchisee_name: value, domain_name: validateCompanyName,
        }));
        setFormData((prev) => {
            const addNewFormData = {
                ...prev, [name]: value, franchisee_name: value, domain_name: validateCompanyName,
            };
            return addNewFormData;
        });
        setErrors((prev) => ({...prev, [name]: ""}));
        if (name === "company_name") {
            if (validateCompanyName.trim()) {
                const domainName = `${validateCompanyName}.therealtordesk.com`;
                await domainValidation(domainName, validateCompanyName);
            }
        }
    };

    // domain validation
    const domainValidation = async (domainName, userInputDomain) => {
        const validateDomain = new FormData();
        validateDomain.append("domain_name", userInputDomain);
        const newErrors = {};
        try {
            const response = await postQuery(API_CHECK_DOMAIN, validateDomain);
            if (response?.data?.data?.domain) {
                const errorMessage = "Business already exist! Please try another.";
                setErrors((prevErrors) => ({
                    ...prevErrors, company_name: errorMessage,
                }));
                return false;
            } else {
                setErrors((prevErrors) => ({...prevErrors, company_name: ""}));
                return true;
            }
        } catch (error) {
            newErrors.server = "Failed to validate business. Please try again later.";
        }
        return newErrors;
    };

    //handle file upload
    const handleFileChange = (e) => {
        const identificationProof = e.target.files[0];
        const validTypes = ["image/jpeg", "image/png", "image/jpg", "image/svg", "application/pdf",];
        if (!validTypes.includes(identificationProof.type)) {
            setErrors((prevErrors) => ({
                ...prevErrors, identification_proof: "Invalid file type. Only JPG, JPEG, PNG, SVG, and PDF are allowed.",
            }));
            setFormData((prevState) => ({
                ...prevState, identification_proof: identificationProof,
            }));
            return false;
        }
        if (!identificationProof) {
            setErrors((prevErrors) => ({
                ...prevErrors, identification_proof: "Identification Proof is required.",
            }));
            return false;
        }
        if (identificationProof.size > 2 * 1024 * 1024) {
            setErrors((prevErrors) => ({
                ...prevErrors, identification_proof: "File size must be less than 2MB.",
            }));
            setFormData((prevState) => ({
                ...prevState, identification_proof: identificationProof,
            }));
            return false;
        }
        setFormData((prevState) => ({
            ...prevState, identification_proof: identificationProof,
        }));
        setErrors((prevErrors) => ({
            ...prevErrors, identification_proof: "",
        }));
        return true;
    };

    const gstNoValidate = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[0-9]{1}[A-Z]{1}[A-Z0-9]{1}$/;
    const user_name = `${formData.salutation} ${formData.first_name} ${formData.last_name}`.trim();

    // Send OTP and store form data
    const handleNextClick = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        if (!formData.package_id) {
            setIsLoading(false);
            alert("Package is not selected.");
            return;
        }
        const validationErrors = dataValidation();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            setIsLoading(false);
            return;
        }
        const identificationFile = document.getElementById("identificationFileUpload");
        if (identificationFile) {
            const proofFile = identificationFile.files[0];
            if (!handleFileChange({target: {files: [proofFile]}})) {
                setIsLoading(false);
                return;
            }
        }
        const {gst_no} = formData;
        if (gst_no && !gstNoValidate.test(gst_no)) {
            setErrors((prevErrors) => ({
                ...prevErrors, gst_no: "Invalid GST number format.",
            }));
            setIsLoading(false);
            return;
        }
        setErrors((prevErrors) => ({
            ...prevErrors, gst_no: "",
        }));

        /*const passwordValidate = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9]).{8,}$/;
        if (!passwordValidate.test(formData.password)) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                password: "Password must be at least 8 characters, contain a character, number, and special character.",
            }));
            setIsLoading(false);
            return;
        }*/

        const domainValidationResult = await domainValidation(formData.company_name, formData.domain_name);
        if (!domainValidationResult) {
            setIsLoading(false);
            return;
        }

        try {
            const newErrors = {};
            const otpData = new FormData();
            otpData.append("email", formData.email);
            otpData.append("country_code", formData.country_code);
            otpData.append("contact_no", formData.contact_no);
            otpData.append("send_otp", 1);
            otpData.append("user_name", user_name);
            const response = await postQuery(API_CHECK_EMAIL, otpData);
            if (response?.data?.success === 1 && response?.data?.data?.otp) {
                setSentOtp(response.data.data.otp);
                setSentEmail(formData.email);
                setOtpExpiresTime(120);
                setIsOtpExpired(false);
                setIsOtpFormVisible(true);
                setIsRegisterFormVisible(false);
            } else {
                if (response?.data?.data?.email === "Email Already Exist!") {
                    newErrors.email = "This email is already registered.";
                    setErrors((prevErrors) => ({
                        ...prevErrors, ...newErrors,
                    }));
                    setIsLoading(false);
                    return false;
                }
                if (response?.data?.data?.contact_no === "Contact Number Already Exist!") {
                    newErrors.contact_no = "Contact number is already registered!";
                    setErrors((prevErrors) => ({
                        ...prevErrors, ...newErrors,
                    }));
                    setIsLoading(false);
                    return false;
                }
            }
        } catch (error) {
            setIsLoading(false);
            setErrors({email: "Error sending OTP. Please try again later."});
        }
        setIsLoading(false);
    };

    // Resend OTP
    const handleReSendOtp = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        try {
            const otpData = new FormData();
            otpData.append("email", formData.email);
            otpData.append("country_code", formData.country_code);
            otpData.append("contact_no", formData.contact_no);
            otpData.append("send_otp", 1);
            otpData.append("user_name", user_name);
            const response = await postQuery(API_CHECK_EMAIL, otpData);
            if (response?.data?.success === 1 && response?.data?.data?.otp) {
                setOtpReSent(response.data.data.otp);
                setOtpExpiresTime(120);
                setIsOtpExpired(false);
                setResendOtpDisabled(true);
                setErrors({newOtp: "New OTP has been sent to your email."});
            } else {
                setErrors({newOtp: "Failed to send New OTP. Please try again."});
            }
        } catch (error) {
            setErrors({newOtp: "Error resending OTP. Please try again later."});
        }
        setIsLoading(false);
    };

    // handle input otp
    const handleInputChangeOtp = (e) => {
        const {name, value} = e.target;
        setOtpFormData((prevState) => ({
            ...prevState, [name]: value,
        }));
    };

    useEffect(() => {
        let interval;
        if (resendOtpDisabled) {
            interval = setInterval(() => {
                setReSendTimer((prev) => {
                    if (prev <= 1) {
                        clearInterval(interval);
                        setResendOtpDisabled(false);
                        return 60;
                    }
                    return prev - 1;
                });
            }, 1000);
        }
        return () => clearInterval(interval);
    }, [resendOtpDisabled]);

    // OTP Expiry Timer (2 minutes)
    useEffect(() => {
        if (otpExpiresTime > 0) {
            const expirationInterval = setInterval(() => {
                setOtpExpiresTime((prev) => prev - 1);
            }, 1000);
            return () => clearInterval(expirationInterval);
        } else {
            setIsOtpExpired(true);
        }
    }, [otpExpiresTime]);

    // Validate OTP
    const validateOtp = () => {
        if (isOtpExpired) {
            setErrors((prevErrors) => ({
                ...prevErrors, otpExpire: "OTP has expired. Please resend a new OTP.",
            }));
            return false;
        }
        if ((otpFormData.otp === sentOtp || otpFormData.otp === otpReSent) && formData.email === sentEmail) {
            setErrors((prevErrors) => ({
                ...prevErrors, otpValidate: "",
            }));
            return true;
        } else {
            setErrors((prevErrors) => ({
                ...prevErrors, otpValidate: "Invalid OTP. Please try again.",
            }));
            return false;
        }
    };

    const handleOtpSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        if (!otpFormData.otp) {
            setErrors((prevErrors) => ({
                ...prevErrors, otpValidate: "OTP is required.",
            }));
            setIsLoading(false);
            return false;
        }
        const isOtpValid = validateOtp();
        if (!isOtpValid) {
            setIsLoading(false);
            return false;
        }
        if (!isCheckedTermsAndCond) {
            setErrors((prevErrors) => ({
                ...prevErrors, termAndCondition: "You must accept the Terms and Conditions.",
            }));
            setIsLoading(false);
            return;
        }
        const registrationData = {
            ...formData, otp: otpFormData.otp,
        };
        try {
            const registrationResponse = await postQuery(API_REGISTRATION, registrationData);
            if (registrationResponse?.data?.success === 1) {
                const subscriptionId = registrationResponse.data.data.subscription.subscription_id;
                const options = {
                    key: "rzp_test_EZJCnSKZJmmHrw", subscription_id: subscriptionId, //'sub_PhInkigd652otF'
                    name: "The Realtor Desk", description: `Payment for Plan`, handler: (paymentResponse) => {
                        setIsLoading(false);
                        const {razorpay_payment_id, razorpay_subscription_id} = paymentResponse;
                        navigate("/payment-success", {
                            state: {
                                razorpay_payment_id, razorpay_subscription_id,
                            },
                        });
                    }, theme: {color: "#3399cc"},
                    modal: {
                        onDismiss: function() {
                            setIsLoading(false);
                        },
                        confirm_close: true, // Optional, shows a confirmation dialog if true
                    },
                };
                const rzp = new Razorpay(options);
                rzp.on("payment.failed", (paymentFailedResponse) => {
                    setIsLoading(false);
                    const errorDetails = paymentFailedResponse?.error || {};
                    const {description} = errorDetails;
                    navigate(`/payment-failed/${subscriptionId}`, {
                        state: {
                            description,
                        },
                    });
                });
                rzp.open();
                return true;
            } else {
                setErrors({
                    registration: "Registration failed. Please try again.",
                });
                setIsLoading(false);
                return false;
            }
        } catch (error) {
            setIsLoading(false);
            setErrors({
                registration: "An error occurred. Please try again later.",
            });
            return false;
        }
    };

    /*const handlePasswordVisibility = () => {
        setPasswordVisible((prevState) => !prevState);
    };*/

    const handleCheckboxChange = (e) => {
        const checked = e.target.checked;
        setIsCheckedTermsAndCond(checked);
        if (checked) {
            setErrors((prevErrors) => ({
                ...prevErrors, termAndCondition: "",
            }));
        }
    };

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (<div className="container">
            <Meta title="Registration | The Realtor Desk" description=""/>
            <div className="registrationFrom-container">
                <PricingHeader
                    title="Register your account with us, it's free"
                    subTitle={isRegisterFormVisible ? "Great! Lets Started with personal details" : "OTP Verification"}
                    step1={step1}
                    step2={step2}
                    step3={step3}
                    isLine1Active={true}
                    isLine2Active={false}
                />
                <div className="form-container">
                    <form
                        className={`registration-form ${isRegisterFormVisible ? "" : "hidden"}`}
                        noValidate
                        onSubmit={handleNextClick}
                        method="POST"
                        encType="multipart/form-data"
                    >
                        <div className="form-row multi-column">
                            <div className={`small-input ${errors.salutation ? "input-error" : ""}`}>
                                <label htmlFor="salutation">
                                    <div>Title<span style={{color: "red"}}>*</span></div>
                                    {errors.salutation && (
                                        <div className="tooltip">
                                            <span className="tooltip-icon"><i className="fa fa-exclamation-circle" /></span>
                                            <div className="tooltip-text">{errors.salutation}</div>
                                        </div>
                                    )}
                                </label>
                                <div className="select-wrapper">
                                    <select
                                        name="salutation"
                                        value={formData.salutation}
                                        onChange={handleInputChange}
                                        required
                                    >
                                        <option value="" disabled>
                                            Select Your Title
                                        </option>
                                        <option value="Mr">Mr.</option>
                                        <option value="Ms">Ms.</option>
                                        <option value="Mrs">Mrs.</option>
                                        <option value="Dr">Dr.</option>
                                        <option value="M/S">M/S.</option>
                                    </select>
                                </div>
                            </div>
                            <div className={`${errors.first_name ? "input-error" : ""}`}>
                                <label htmlFor="first_name">
                                    <div>First Name<span style={{color: "red"}}>*</span></div>
                                    {errors.first_name && (
                                        <div className="tooltip">
                                            <span className="tooltip-icon"><i className="fa fa-exclamation-circle" /></span>
                                            <div className="tooltip-text">{errors.first_name}</div>
                                        </div>
                                    )}
                                </label>
                                <input
                                    type="text"
                                    placeholder="Enter your first name"
                                    name="first_name"
                                    value={formData.first_name}
                                    onChange={handleInputChange}
                                    required
                                />
                            </div>
                            <div>
                                <label htmlFor="last_name">Last Name:</label>
                                <input
                                    type="text"
                                    placeholder="Enter your last name"
                                    name="last_name"
                                    value={formData.last_name}
                                    onChange={handleInputChange}
                                />
                            </div>
                        </div>
                        <div className="form-row multi-column">
                            <div className={`${errors.email ? "input-error" : ""}`}>
                                <label htmlFor="email">
                                    <div>Email<span style={{color: "red"}}>*</span></div>
                                    {errors.email && (
                                        <div className="tooltip">
                                            <span className="tooltip-icon"><i className="fa fa-exclamation-circle" /></span>
                                            <div className="tooltip-text">{errors.email}</div>
                                        </div>
                                    )}
                                </label>
                                <input
                                    type="email"
                                    placeholder="Enter your email"
                                    value={formData.email}
                                    name="email"
                                    onChange={handleInputChange}
                                    required
                                />
                            </div>
                            <div className={`${errors.contact_no ? "input-error" : ""}`}>
                                <label htmlFor="contact_no">
                                    <div>Contact Number<span style={{color: "red"}}>*</span></div>
                                    {errors.contact_no && (
                                        <div className="tooltip">
                                            <span className="tooltip-icon"><i className="fa fa-exclamation-circle" /></span>
                                            <div className="tooltip-text">{errors.contact_no}</div>
                                        </div>
                                    )}
                                </label>
                                <div className="country-code-phone-wrapper">
                                    <div className="country-code-wrapper select-wrapper">
                                        <select
                                            name="country_code"
                                            value={formData.country_code}
                                            onChange={handleInputChange}
                                            required
                                        >
                                            {CountryCodeList.map((countryCodes) => (
                                                <option key={countryCodes.id} value={countryCodes.code}>
                                                    {countryCodes.code}
                                                </option>))}
                                        </select>
                                    </div>
                                    <input
                                        type="tel"
                                        name="contact_no"
                                        placeholder="Enter your phone number"
                                        minLength="10"
                                        maxLength="10"
                                        value={formData.contact_no}
                                        onChange={handleInputChange}
                                        required
                                        className="reg-contact-no"
                                        onKeyPress={(e) => {
                                            if (!/[0-9]/.test(e.key)) {
                                                e.preventDefault();
                                            }
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className={`form-row ${errors.identification_proof ? "input-error" : ""}`}>
                            <label htmlFor="identification_proof">
                                <div>Identification Proof<span style={{color: "red"}}>*</span></div>
                                {errors.identification_proof && (
                                    <div className="tooltip">
                                        <span className="tooltip-icon"><i className="fa fa-exclamation-circle" /></span>
                                        <div className="tooltip-text">{errors.identification_proof}</div>
                                    </div>
                                )}
                            </label>
                            <input
                                id="identificationFileUpload"
                                type="file"
                                name="identification_proof"
                                onChange={(e) => handleFileChange(e)}
                                required
                                accept=".jpeg,.png,.jpg,.svg,.pdf"
                            />
                        </div>
                        <div className={`form-row ${errors.company_name ? "input-error" : ""}`}>
                            <label htmlFor="company_name">
                                <div>Company:<span style={{color: "red"}}>*</span></div>
                                {errors.company_name && (
                                    <div className="tooltip">
                                        <span className="tooltip-icon"><i className="fa fa-exclamation-circle" /></span>
                                        <div className="tooltip-text">{errors.company_name}</div>
                                    </div>
                                )}
                            </label>
                            <input
                                type="text"
                                placeholder="Enter your real estate company name"
                                name="company_name"
                                value={formData.company_name}
                                onChange={handleCompanyNameChange}
                                required
                            />
                        </div>
                        <div className="form-row multi-column">
                            <div>
                                <label htmlFor="identification_no">
                                    Pancard
                                </label>
                                <input
                                    type="text"
                                    placeholder="Enter Pancard number"
                                    name="identification_no"
                                    value={formData.identification_no}
                                    onChange={handleInputChange}
                                    maxLength="16"
                                    required
                                />
                            </div>
                            <div>
                                <label htmlFor="gst_no">GST Number</label>
                                <input
                                    type="text"
                                    placeholder="Enter GST Number"
                                    name="gst_no"
                                    value={formData.gst_no}
                                    onChange={handleInputChange}
                                    maxLength="15"
                                />
                            </div>
                        </div>
                        <div className={`form-row ${errors.address_1 ? "input-error" : ""}`}>
                            <label htmlFor="address_1">
                                <div>Address 1<span style={{color: "red"}}>*</span></div>
                                {errors.address_1 && (
                                    <div className="tooltip">
                                        <span className="tooltip-icon"><i className="fa fa-exclamation-circle" /></span>
                                        <div className="tooltip-text">{errors.address_1}</div>
                                    </div>
                                )}
                            </label>
                            <input
                                type="text"
                                placeholder="Flat/HouseNo/Building Name/Company"
                                name="address_1"
                                value={formData.address_1}
                                onChange={handleInputChange}
                                required
                            />
                        </div>
                        <div className={`form-row ${errors.address_2 ? "input-error" : ""}`}>
                            <label htmlFor="address_2">
                                <div>Address 2<span style={{color: "red"}}>*</span></div>
                                {errors.address_2 && (
                                    <div className="tooltip">
                                        <span className="tooltip-icon"><i className="fa fa-exclamation-circle" /></span>
                                        <div className="tooltip-text">{errors.address_2}</div>
                                    </div>
                                )}
                            </label>
                            <input
                                type="text"
                                placeholder="Address (Area and Street)"
                                name="address_2"
                                value={formData.address_2}
                                onChange={handleInputChange}
                                required
                            />
                        </div>
                        <div className="form-row multi-column">
                            <div className={`${errors.locality ? "input-error" : ""}`} style={{position: "relative"}}>
                                <label htmlFor="locality">
                                    <div>Locality<span style={{color: "red"}}>*</span></div>
                                    {errors.locality && (
                                        <div className="tooltip">
                                            <span className="tooltip-icon"><i className="fa fa-exclamation-circle" /></span>
                                            <div className="tooltip-text">{errors.locality}</div>
                                        </div>
                                    )}
                                </label>
                                <input
                                    ref={inputRef}
                                    type="text"
                                    name="locality"
                                    value={localityInput}
                                    onChange={handleLocalityInputChange}
                                    placeholder="Type your locality"
                                />
                                {predictions.length > 0 && (<ul
                                    style={{
                                        position: "absolute",
                                        maxHeight: "200px",
                                        overflowY: "auto",
                                        border: "1px solid #DFDFDF",
                                        background: "#FFFFFF",
                                        zIndex: 999,
                                        width: "100%",
                                        borderRadius: "5px",
                                        listStyle: "none",
                                    }}
                                >
                                    {predictions.map((prediction) => (<li
                                        key={prediction.placeId}
                                        onClick={() => handleLocalitySelect(prediction)}
                                        style={{
                                            padding: "5px 10px", cursor: "pointer", borderBottom: "1px solid #DFDFDF", display: "flex", flexDirection: "column"
                                        }}
                                    >
                                        <strong className="prediction-title">
                                            {prediction.description}
                                        </strong>

                                        <small className="prediction-subtitle">
                                            {prediction.fullDescription}
                                        </small>
                                    </li>))}
                                </ul>)}
                            </div>
                            <div className={`${errors.city ? "input-error" : ""}`} style={{position: "relative"}}>
                                <label htmlFor="city">
                                    <div>City <span style={{color: "red"}}>*</span></div>
                                    {errors.city && (
                                        <div className="tooltip">
                                            <span className="tooltip-icon"><i className="fa fa-exclamation-circle" /></span>
                                            <div className="tooltip-text">{errors.city}</div>
                                        </div>
                                    )}
                                </label>
                                <input
                                    type="text"
                                    name="city"
                                    value={cityInput}
                                    onChange={handleCityInputChange}
                                    placeholder="Type your city"
                                    required
                                    style={{width: "100%"}}
                                />
                                {filteredCities.length > 0 && (<ul
                                    style={{
                                        position: "absolute",
                                        maxHeight: "200px",
                                        overflowY: "auto",
                                        border: "1px solid #DFDFDF",
                                        background: "#FFFFFF",
                                        zIndex: 999,
                                        width: "100%",
                                        borderRadius: "5px",
                                        listStyle: "none",
                                    }}
                                >
                                    {filteredCities.map((city) => (<li
                                        key={city.id}
                                        value={city.eloc}
                                        style={{
                                            padding: "5px 10px", cursor: "pointer", borderBottom: "1px solid #DFDFDF", display: "flex", flexDirection: "column"
                                        }}
                                        onClick={() => handleCitySelect(city)}
                                    >
                                        {city.city}
                                    </li>))}
                                </ul>)}
                            </div>
                        </div>
                        {/*<div className={`form-row ${errors.password ? "input-error" : ""}`}>
                            <label htmlFor="password">
                                <div>Password<span style={{color: "red"}}>*</span></div>
                                {errors.password && (
                                    <div className="tooltip">
                                        <span className="tooltip-icon"><i className="fa fa-exclamation-circle" /></span>
                                        <div className="tooltip-text">{errors.password}</div>
                                    </div>
                                )}
                            </label>
                            <div className="password-container">
                                <input
                                    type={passwordVisible ? "text" : "password"}
                                    placeholder="Enter Your Password"
                                    name="password"
                                    value={formData.password}
                                    onChange={handleInputChange}
                                    required
                                />
                                <span
                                    className="eye-icon"
                                    onClick={handlePasswordVisibility}
                                    style={{cursor: "pointer"}}
                                >
                                  <FontAwesomeIcon
                                      icon={passwordVisible ? faEyeSlash : faEye}
                                      size="lg"
                                  />
                                </span>
                            </div>
                        </div>*/}
                        <button className="registrationFrom-next-btn primary" type="submit" disabled={isLoading}>
                            {isLoading ? (<span className="spinner"></span>) : 'Next'}
                        </button>
                    </form>
                    <form
                        className={`otp-form ${isOtpFormVisible ? "" : "hidden"}`}
                        onSubmit={handleOtpSubmit}
                        method="POST"
                        encType="multipart/form-data"
                        noValidate
                    >
                        <div className={`form-row ${(errors.otpValidate || errors.otpExpire) ? "input-error" : ""}`}>
                            <label htmlFor="otp">
                                <div>Enter OTP <span style={{color: "red"}}>*</span></div>
                                {(errors.otpValidate || errors.otpExpire) && (
                                    <div className="tooltip">
                                        <span className="tooltip-icon"><i className="fa fa-exclamation-circle" /></span>
                                        <div className="tooltip-text">
                                            {errors.otpExpire ? (errors.otpExpire) : errors.otpValidate ? (errors.otpValidate) : ""}
                                        </div>
                                    </div>
                                )}
                            </label>
                            <input
                                type="tel"
                                placeholder="Enter OTP"
                                value={otpFormData.otp}
                                name="otp"
                                onChange={handleInputChangeOtp}
                                inputMode="numeric"
                                pattern="\d{6}"
                                maxLength="6"
                                required
                            />
                        </div>
                        <div className="form-row multi-column-check">
                            <input
                                type="checkbox"
                                name="accept"
                                checked={isCheckedTermsAndCond}
                                onChange={handleCheckboxChange}
                            />
                            <p>
                                I accept the Term of Conditions
                                <span style={{color: "red"}}>*</span>
                            </p>
                            <p>
                                Click here to view
                                <Link
                                    to="/term-and-condition"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{
                                        color: "#1512d4cf",
                                        textDecoration: "underline",
                                        cursor: "pointer",
                                        marginLeft: "5px",
                                    }}
                                >
                                    Teams and Conditions
                                </Link>
                            </p>
                        </div>
                        <div className="termAndCond-error">
                            {errors.termAndCondition && (<p style={{color: "red"}}>{errors.termAndCondition}</p>)}
                        </div>
                        <div className="opt-btn">
                            <button
                                className="resend-otp primary"
                                onClick={handleReSendOtp}
                                type="button"
                                disabled={!isOtpExpired || isLoading}
                            >
                                {isLoading ? (<span className="spinner"></span>) : isOtpExpired ? "Resend OTP" : `Resend OTP (${otpExpiresTime}s)`}
                            </button>
                            <button className="submit-otp primary" type="submit" disabled={isLoading}>
                                {isLoading ? (<span className="spinner"></span>) : 'Submit OTP'}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>);
};

export default RegistrationForm;
